import getFetchOptions from './utils/getFetchOptions.js';
import fetchJSON from './utils/fetchJSON.js';
const options = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-fwd-svc': 'atc'
  }
};
function getPaymentCalculationFetcher(path) {
  return {
    path: path + 'rest/retailing',
    async fetch() {
      let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      let fetchTotalPayment = arguments.length > 1 ? arguments[1] : undefined;
      try {
        const endpoint = `${this.path}/${fetchTotalPayment ? 'budget' : 'payments'}`;
        value = value.startsWith('?') ? value : `?${value}`;
        const onError = error => {
          if (window && window?.newrelic) {
            window?.newrelic?.addPageAction('ThirdPartyError', {
              id: 'paymentCalc',
              component: 'PaymentCalculationFetcher',
              message: 'National AVG Rate Fallback',
              status: error?.status,
              requestParams: value
            });
          }
        };
        return await fetchJSON(endpoint + value, getFetchOptions(options), onError);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching payment calculation data: ', error);
        onError(error);
        return {};
      }
    }
  };
}
export { getPaymentCalculationFetcher as default };
